export default "__VITE_ASSET__CleYhEHL__"